import { connect } from "react-redux";
import LogRocket from "logrocket";
import { useEffect } from "react";
import { IS_LOG_ROCKET_ON } from "../../helper/constants";

const InitializeLogRocket = (props) => {
  const { userId, firstName, lastName, email } = props;

  useEffect(() => {
    // To handle page refresh
    if (IS_LOG_ROCKET_ON && userId && firstName && lastName && email) {
      LogRocket.identify(userId, {
        name: `${firstName} ${lastName}`,
        email: email,
      });
    }
  }, []);
  return props.children;
};

const mapStateToProps = (state) => {
  return {
    ...state.auth,
  };
};

export default connect(mapStateToProps, null)(InitializeLogRocket);
